import moment from 'moment'

import { useCallback } from 'react'
import { dateFilter } from 'app/dataProviders/filter-items'

import { PlainInputDateBox } from 'app/common/ui-next/_filter-compilations/plain-input-date'
import { encashmentsDateFormat } from 'app/dataTypes/reports/data'



const getYesterdayDate = () => {
  const yesterday = moment().subtract(1, 'days').format(encashmentsDateFormat)
  return yesterday
}

type Props = {
  id: string
  pending: boolean
}

export const DateFilter = ({ id, pending }: Props) => {
  const changePeriodToDefault = useCallback(() => {
    return getYesterdayDate()
  }, [])

  return (
    <PlainInputDateBox
      id={id}
      loading={pending}
      dateFormat={encashmentsDateFormat}
      dataBoxData={dateFilter}
      getDefaultState={changePeriodToDefault}
    />
  )
}
